import React, { useState } from "react";
import { Text } from "react-native";

const ScalableText = ({
  fontSize,
  children,
  style,
  numberOfLines,
  minSize = 14,
  ...rest
}) => {
  const [currentFont, setCurrentFont] = useState(fontSize);

  return (
    <Text
      numberOfLines={numberOfLines}
      style={[style, { fontSize: currentFont }]}
      onTextLayout={(e) => {
        const { lines } = e.nativeEvent;
        if (lines.length > numberOfLines) {
          setCurrentFont((currrentFontSize) => {
            const newFontSize = Math.max(currrentFontSize - 2, minSize);
            if (newFontSize === currrentFontSize) return currrentFontSize;
            return newFontSize;
          });
        }
      }}
      {...rest}
    >
      {children}
    </Text>
  );
};

export default ScalableText;
